import React from 'react'
import { ApplicationPage } from '.'
import { ApplicantType, ApplicationType } from 'shared'

export function PersonnelLoanPage(){
    return <ApplicationPage type={ApplicationType.Personnel} applicantType={ApplicantType.Private} />
}